mutation SetPlatformStripeBillingMode(
  $platformId: ID!
  $mode: StripeBillingMode!
) {
  setPlatformStripeBillingMode(platformId: $platformId, mode: $mode) {
    id
    stripeBillingMode
  }
}
